import SharedNewsAndInsightsFeatured, {
  INewsAndInsightsFeatured,
} from '@organisms/NewsAndInsightsFeatured/NewsAndInsightsFeatured';

const HeadlineAndTextBlock = (props: INewsAndInsightsFeatured) => (
  <div className="tw-mb-12 tw-border-b tw-border-grey-30 tw-pb-10 md:tw-mb-0 md:tw-pb-20">
    <SharedNewsAndInsightsFeatured {...props} />
  </div>
);

export default HeadlineAndTextBlock;
